module.exports = __webpack_public_path__ + "pl.svg?b4850bf132d644b612dae0ecd20a36cd";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pl.svg
// module id = 912
// module chunks = 27